import React, { useEffect, useState } from 'react';

import type { DataExport, MailersExport } from 'bundles/connect/types';
import ExportList from '../data_exports/export_list';
import { Form, InputGroup, Nav } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faHouseBuilding, faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import MailerExportList from '../mailers/exports/mailer_export_list';

type Props = {
  dataExports: DataExport[];
  mailerExports: MailersExport[];
}

const DATA_EXPORT_TAB = 'data_exports';
const MAILER_EXPORT_TAB = 'mailer_exports';

const getInitialTab = (): string => {
  const params = new URLSearchParams(window.location.search);
  const exportTab = params.get('export_tab');

  if (exportTab === MAILER_EXPORT_TAB) {
    return MAILER_EXPORT_TAB;
  }
  return DATA_EXPORT_TAB;
};

export default function ExportSettings({ dataExports, mailerExports }: Props) {
  const [searchText, setSearchText] = useState('');
  const [tab, setTab] = useState(getInitialTab());
  const [searchDataExportResults, setSearchDataExportResults] = useState(dataExports);
  const [searchMailerExportResults, setSearchMailerExportResults] = useState(mailerExports);

  useEffect(() => {
    if (!searchText) {
      setSearchDataExportResults(dataExports);
      setSearchMailerExportResults(mailerExports);
    } else {
      setSearchDataExportResults(
        dataExports.filter(e => e.name.toLowerCase().includes(searchText))
      );
      setSearchMailerExportResults(
        mailerExports.filter(e => e.name.toLowerCase().includes(searchText))
      );
    }
  }, [searchText]);

  const handleTabChange = (key: string | null) => {
    if (key) {
      setTab(key);
      const url = new URL(window.location.href);
      url.searchParams.set('export_tab', key);
      history.replaceState({}, '', url.toString());
    }
  };

  return (
    <>
      <h5 className="fw-semibold mb-6">Export Files</h5>
      <Form.Label className="mb-0">Search Files</Form.Label>
      <InputGroup className="my-2">
        <InputGroup.Text>
          <FontAwesomeIcon icon={faMagnifyingGlass}/>
        </InputGroup.Text>
        <Form.Control
          placeholder="Search by export name"
          type="text"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
        />
      </InputGroup>
      <Nav activeKey={tab} variant="tabs" onSelect={handleTabChange}>
        <Nav.Item>
          <Nav.Link className="border-start-0 py-2" eventKey={DATA_EXPORT_TAB}>
            <FontAwesomeIcon icon={faHouseBuilding} />
            Properties & Activities ({searchDataExportResults.length})
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className="py-2" eventKey={MAILER_EXPORT_TAB}>
            <FontAwesomeIcon icon={faEnvelope} />
            Mailers ({searchMailerExportResults.length})
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <div className="py-6">
        {tab === DATA_EXPORT_TAB && (
          <ExportList exports={searchDataExportResults} />
        )}
        {tab === MAILER_EXPORT_TAB && (
          <MailerExportList mailerExports={searchMailerExportResults} />
        )}
      </div>
    </>
  );
}
